import { useState } from "react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { Reveal } from "@/components/Reveal";
import { Input } from "@/components/ui/input";
import { Checkbox } from "@/components/ui/checkbox";

const fieldCls = "bg-transparent border border-charred/20 rounded-md focus-visible:ring-terracotta text-charred placeholder:text-charred/40";

export default function Newsletter() {
  const [form, setForm] = useState({ nome: "", contatto: "", consenso: false, website: "" });
  const [sending, setSending] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!form.consenso) {
      toast.error("Devi dare il consenso per iscriverti alla lista informativa.");
      return;
    }
    setSending(true);
    try {
      await api.post("/subscribe", form);
      toast.success("Iscrizione registrata! Riceverai il menù del giorno e le novità.");
      setForm({ nome: "", contatto: "", consenso: false, website: "" });
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally {
      setSending(false);
    }
  };

  return (
    <section className="py-20 md:py-28 bg-olive/10 border-y border-olive/20">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
        <Reveal>
          <p className="text-xs uppercase tracking-[0.25em] text-olive-dark font-medium">Lista informativa</p>
          <h2 className="mt-3 font-serif text-3xl md:text-5xl text-charred tracking-tight">Ricevi il menù del giorno</h2>
          <p className="mt-4 text-sm md:text-base text-charred/70 leading-relaxed max-w-md">
            Vuoi conoscere in anticipo i nostri piatti? Iscriviti alla lista informativa di SAPORÉ per ricevere aggiornamenti sul menù, sulle novità e sulle proposte speciali.
          </p>
        </Reveal>
        <Reveal delay={0.1}>
          <form onSubmit={submit} className="bg-cream border border-charred/10 rounded-lg p-6 md:p-8" data-testid="newsletter-form">
            <input type="text" value={form.website} onChange={(e) => setForm((f) => ({ ...f, website: e.target.value }))}
              className="hidden" tabIndex={-1} autoComplete="off" aria-hidden="true" />
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <Input required placeholder="Il tuo nome *" value={form.nome} onChange={(e) => setForm((f) => ({ ...f, nome: e.target.value }))} className={fieldCls} data-testid="newsletter-name-input" />
              <Input required placeholder="Telefono o e-mail *" value={form.contatto} onChange={(e) => setForm((f) => ({ ...f, contatto: e.target.value }))} className={fieldCls} data-testid="newsletter-contact-input" />
            </div>
            <label className="mt-4 flex items-start gap-3 text-xs text-charred/70 cursor-pointer">
              <Checkbox checked={form.consenso} onCheckedChange={(v) => setForm((f) => ({ ...f, consenso: !!v }))} data-testid="newsletter-consent-checkbox" />
              Acconsento a ricevere comunicazioni informative da SAPORÉ. Potrò cancellarmi in qualsiasi momento. *
            </label>
            <button type="submit" disabled={sending} data-testid="newsletter-submit-btn"
              className="mt-5 w-full rounded-full bg-olive-dark text-cream px-6 py-3 text-sm font-semibold hover:bg-olive transition-colors disabled:opacity-60">
              {sending ? "Invio in corso…" : "Ricevi gli aggiornamenti"}
            </button>
          </form>
        </Reveal>
      </div>
    </section>
  );
}
